import React from "react";
import {
  Container,
  Box,
  Typography,
  Stack,
  useMediaQuery,
} from "@mui/material";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import EmailOutlinedIcon from "@mui/icons-material/EmailOutlined";
import LocationOnOutlinedIcon from "@mui/icons-material/LocationOnOutlined";
import WifiCalling3OutlinedIcon from "@mui/icons-material/WifiCalling3Outlined";
import WatchLaterOutlinedIcon from "@mui/icons-material/WatchLaterOutlined";
import Form from "./Form";
import { useTranslation } from "react-i18next";

export default function ContactUs() {
  const matches = useMediaQuery("(min-width:1140px)");
  const { t } = useTranslation();

  return (
    <div id={t("Contact Us")}>
      <div
        style={{
          position: "relative",
          marginTop: "150px",
          marginBottom: "50px",
        }}
      >
        <Typography
          sx={{
            display: "flex",
            color: "white",
            fontSize: "35px",
            flexWrap: "wrap",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          {t("Contact Us")}
        </Typography>

        <Container
          sx={{
            display: "flex",
            flexWrap: "wrap",
            justifyContent: "center",
            alignItems: "center",
            padding: "20px",
          }}
        >
          {matches && (
            <Box
              sx={{
                height: matches ? "300px" : "800px",
                width: matches ? "1200px" : "1000px",
                bgcolor: "transparent",
                borderRadius: "50px 50px 50px 50px",
                padding: "20px",
                display: "flex",
                flexWrap: "wrap",
                borderTop: matches ? "2px solid white" : "",
                justifyContent: "center",
                alignItems: "center",
                borderRight: matches ? "2px solid white" : "",
                borderLeft: matches ? "2px solid white" : "",
                borderBottom: matches ? "2px solid #FEFEFE4F" : "",
                height: "500px",
              }}
            ></Box>
          )}
          <Box
            sx={{
              height: matches ? "300px" : "800px",
              width: matches ? "1080px" : " ",
              bgcolor: matches ? "#FFFFFF33" : "",
              borderRadius: "50px",
              padding: "20px",
              position: matches ? "absolute" : "",
              top: "50px",
              height: "500px",
              justifyContent: "center",
              alignItems: "center",
              display: "flex",
              flexWrap: "wrap",
              marginBottom: matches ? "" : "600px",
            }}
          >
            <Stack
              gap={matches ? 4 : 1}
              direction={matches ? "row" : "column"}
              sx={{
                alignItems: "center",
                diaplay: matches ? "" : "flex",
                flexWrap: matches ? "" : "wrap",
                justifyContent: matches ? "" : "center",
              }}
            >
              <Stack direction="column" gap={2}>
                <Card
                  sx={{
                    width: "250px",
                    padding: "20px",
                    height: "7rem",
                    borderRadius: "20px",
                    bgcolor: "#759BE39C",
                    position: "relative",
                  }}
                >
                  <CardContent>
                    <Typography sx={{ color: "white" }}>
                      <Stack direction="row">
                        <Stack>
                          <Typography sx={{ color: "#030D55" }}>
                            {t("Address")}
                            <Typography sx={{ color: "white" }}>
                              {t("Damascus,Al-Fardos Tower")}
                              <br />
                              <br />
                            </Typography>
                          </Typography>
                        </Stack>
                        <LocationOnOutlinedIcon sx={{ color: "white" }} />
                      </Stack>
                    </Typography>
                  </CardContent>
                </Card>
                <Card
                  sx={{
                    width: "250px",
                    height: "7rem",
                    padding: "20px",
                    borderRadius: "20px",
                    bgcolor: "#759BE39C",
                    position: "relative",
                  }}
                >
                  <CardContent>
                    <Typography sx={{ color: "white" }}>
                      <Stack direction="row" gap={5}>
                        <Stack>
                          <Typography sx={{ color: "#030D55" }}>
                            {t("Call Us")}
                          </Typography>
                          <Typography sx={{ color: "white" }}>
                            +963 11 22 322 46 <br />
                            +963 11 22 322 45
                          </Typography>
                        </Stack>
                        <WifiCalling3OutlinedIcon sx={{ color: "white" }} />
                      </Stack>
                    </Typography>
                  </CardContent>
                </Card>
                <Box></Box>
              </Stack>

              <Stack direction="column" gap={2}>
                <Card
                  sx={{
                    width: "250px",
                    padding: "20px",
                    height: "7rem",
                    borderRadius: "20px",
                    bgcolor: "#759BE39C",
                    position: "relative",
                  }}
                >
                  <CardContent>
                    <Typography sx={{ color: "white" }}>
                      <Stack direction="row">
                        <Stack>
                          <Typography sx={{ color: "#030D55" }}>
                            {t("Email")}
                            <Typography sx={{ color: "white" }}>
                              info@focustradingcompany.com <br />
                              <br />
                            </Typography>
                          </Typography>
                        </Stack>
                        <EmailOutlinedIcon
                          sx={{ color: "white", marginLeft: "-50px" }}
                        />
                      </Stack>
                    </Typography>
                  </CardContent>
                </Card>
                <Card
                  sx={{
                    width: "250px",
                    height: "7rem",
                    padding: "20px",
                    borderRadius: "20px",
                    bgcolor: "#759BE39C",
                    position: "relative",
                  }}
                >
                  <CardContent>
                    <Typography sx={{ color: "white" }}>
                      <Stack direction="row" gap={5}>
                        <Stack>
                          <Typography sx={{ color: "#030D55" }}>
                            {t("Open Hours")}
                          </Typography>
                          <Typography sx={{ color: "white" }}>
                            {t("Saturday - Thursday")} <br />
                            9:00AM - 05:00PM
                          </Typography>
                        </Stack>
                        <WatchLaterOutlinedIcon sx={{ color: "white" }} />
                      </Stack>
                    </Typography>
                  </CardContent>
                </Card>
                <Box></Box>
              </Stack>
              <Form />
            </Stack>
          </Box>
        </Container>
      </div>
    </div>
  );
}
